var modalList = [].slice.call(document.querySelectorAll('[data-modal]'));

// var tooltipList = modalList.map(function (el) {
    // if(el.dataset.modal == "uploadImage") {
    //     el.addEventListener('click', function(event) {
    //         event.preventDefault();
    //         uploadImage(el);
    //     });
    // }

    // if(el.dataset.modal == "uploadLogo") {
    //     el.addEventListener('click', function(event) {
    //         event.preventDefault();
    //         uploadLogo(el);
    //     });
    // }

    // if(el.dataset.modal == "clearLogo") {
    //     el.addEventListener('click', function(event) {
    //         event.preventDefault();
    //         clearLogo(el);
    //     });
    // }

    // if(el.dataset.modal == "support") {
    //     el.addEventListener('click', function(event) {
    //         event.preventDefault();
    //         handleSupport();
    //     });
    // }
// });

modalList.forEach(el => {
    el.addEventListener('click', function(event) {
        event.preventDefault();

        if(el.dataset.modal == "uploadImage") {
            uploadImage(el);
        }
        if(el.dataset.modal == "uploadLogo") {
            uploadLogo(el);
        }
        if(el.dataset.modal == "clearLogo") {
            clearLogo(el);
        }
        if(el.dataset.modal == "support") {
            handleSupport();
        }
    });
});


function isOversized(size){
    if(size/(1024*1024) > 5){
        handleGeneralModal();

        var headline = document.getElementById('new_modal-headline');
        headline.innerHTML = 'Das ausgewählte Bild überschreitet die maximal zulässige Uploadgröße (5 MB).';

        var btn_area = document.getElementById('new_modal-button-area');
        btn_area.innerHTML = '<button type="button" class="grey-button" onclick="document.getElementById(\'general-modal\').style.visibility = \'hidden\'" style="margin-bottom:0">OK</button>';

        return true;
    }
    return false;
}


/**
 *  Handle Modals
*/
function handleSupport() {
    var modal = document.getElementById('support-modal');
    modal.style.visibility = (modal.style.visibility == "visible") ? "hidden" : "visible";

    const close = modal.querySelector('[data-close]');

    close.addEventListener('click', function() {
        modal.style.visibility = 'hidden';
    });
}

function handleGeneralModal() {
    var modal = document.getElementById('general-modal');
    modal.style.visibility = (modal.style.visibility == "visible") ? "hidden" : "visible";

    const close = modal.querySelector('[data-close]');

    close.addEventListener('click', function() {
        modal.style.visibility = 'hidden';
    });
}

function handlePreviewModal() {
    var modal = document.getElementById('preview-modal');
    modal.style.visibility = (modal.style.visibility == "visible") ? "hidden" : "visible";

    const close = modal.querySelector('[data-close]');

    close.addEventListener('click', function() {
        modal.style.visibility = 'hidden';
    });
}

function handleModal(modalName) {
    var modal = document.getElementById(modalName);
    modal.style.visibility = (modal.style.visibility == "visible") ? "hidden" : "visible";

    const close = modal.querySelector('[data-close]');

    close.addEventListener('click', function() {
        let myBtn = document.getElementById('new_modal-footer');
        var label = myBtn.querySelector('label');
        if (myBtn.children.length > 0) {
            myBtn.removeChild(label);
        }
        modal.style.visibility = 'hidden';
    });
}

function uploadImage(element) {
    let myBtn = document.getElementById('new_modal-footer');
    const myInput = element.nextElementSibling;

    var label = document.createElement('label');
    label.textContent = "EIGENES BILD LADEN";
    label.className += " grey-button";
    label.htmlFor = myInput.id;

    if (myBtn.children.length == 0) {
        myBtn.appendChild(label);
    }

    if(myInput.classList.contains("upload-mitarbeiter-tips-image") || myInput.classList.contains("upload-mitarbeiter-image")) {
        handleModal('upload-mitarbeitertip-modal');
    }
    else {
        handleModal('upload-picture-modal');
    }

    myInput.onchange = function() {
        const placeholder = this.parentNode;

        if(this.files && this.files[0]) {
            if(isOversized(this.files[0].size)){
                $(this).val("").change();
                return;
            }
            const reader = new FileReader();

            reader.onload = function() {
                placeholder.style.backgroundImage = "url(" + reader.result + ")";
            }
            reader.readAsDataURL(this.files[0]);
        }

        if(myInput.classList.contains("upload-mitarbeiter-tips-image") || myInput.classList.contains("upload-mitarbeiter-image")) {
            handleModal('upload-mitarbeitertip-modal');
        }
        else {
            handleModal('upload-picture-modal');
        }

        if (myBtn.children.length > 0) {
            myBtn.removeChild(label);
        }
    }
}


function uploadLogo(element) {
    handleModal('upload-picture-modal');

    let myBtn = document.getElementById('new_modal-footer');
    const myInput = element.nextElementSibling;

    var label = document.createElement('label');
    label.textContent = "EIGENES BILD LADEN";
    label.className += " grey-button";
    label.htmlFor = myInput.id;

    if (myBtn.children.length == 0) {
        myBtn.appendChild(label);
    }

    const partner_logo = document.getElementById('partner_logo');

    myInput.onchange = function() {
        const placeholder = this.parentNode;
        const clear_logo = document.querySelector("div[data-modal='clearLogo']");

        if(this.files && this.files[0]) {
            if(isOversized(this.files[0].size)){
                $(this).val("").change();
                return;
            }
            const reader = new FileReader();
            reader.onload = function() {
                placeholder.style.backgroundImage = "url(" + reader.result + ")";
                partner_logo.value = reader.result;
            }
            reader.readAsDataURL(this.files[0]);

            $("#scala-logo-id").val("0");
        }

        clear_logo.style.display = "block";

        handleModal('upload-picture-modal');

        if (myBtn.children.length > 0) {
            myBtn.removeChild(label);
        }
    }
}

function clearLogo(element) {
  const placeholder = element.parentNode;
  const fileInput = document.getElementById('partner-logo-file');
  const hiddenLogoInput = document.getElementById('partner_logo');
  const clear_logo = document.querySelector("div[data-modal='clearLogo']");

  placeholder.style.backgroundImage = "url('')";

  fileInput.value = "";
  hiddenLogoInput.value = "";
  clear_logo.style.display = "none";
}
export { handleGeneralModal, handlePreviewModal }
